import { Divider, Drawer, Loader, Stack } from '@mantine/core';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { CopyableText } from '../CopyableText';
import { DetailViewProvider } from './DetailViewContext';

export function DetailDrawer({
    opened,
    onClose,
    title,
    subtitle,
    loading,
    footer,
    children,
}: {
    opened: boolean;
    onClose: () => void;
    title: string;
    subtitle?: string;
    loading?: boolean;
    footer?: ReactNode;
    children: ReactNode;
}) {
    const { t } = useTranslation();

    return (
        <Drawer opened={opened} onClose={onClose} title={title} position="right" size="xl" padding="lg">
            <Stack gap="lg">
                {subtitle ? (
                    <CopyableText
                        size="sm"
                        c="dimmed"
                        mt={-8}
                        copyValue={subtitle}
                        label={t('common.copy.id')}
                        ff="monospace"
                    >
                        {subtitle}
                    </CopyableText>
                ) : null}
                {loading ? <Loader size="sm" /> : null}
                <DetailViewProvider>{children}</DetailViewProvider>
                {footer ? (
                    <>
                        <Divider />
                        {footer}
                    </>
                ) : null}
            </Stack>
        </Drawer>
    );
}
